import React from 'react';

import emptyStoreListingsSrc from '../../../assets/img/store-listing-empty-state.svg';
import { StoreListingsTable } from './StoreListingsTable';

export function DraftStoreListingsTable() {
  return (
    <StoreListingsTable
      storeListingStatus="draft"
      noDataIndication={{
        title: 'No draft product listings found',
        assetSrc: emptyStoreListingsSrc,
      }}
    />
  );
}
